/**
 * Format a Date as YYYY-MM-DD in the user's *local* timezone.
 *
 * IMPORTANT: do NOT use `Date.toISOString().slice(0, 10)` — that returns UTC
 * which can differ from local time by up to ±1 day. Calendar code throughout
 * this feature treats date keys as local dates (mapping events into day
 * cells, comparing to "today", grouping by day). Mixing UTC keys with local
 * comparisons silently breaks the now-line, today-highlight, and week
 * navigation in the user's evening (west of UTC) or morning (east of UTC).
 *
 * Example: at 23:00 PDT on 2026-04-25, `new Date()` is "Apr 25" locally but
 * `toISOString()` is "2026-04-26T06:00:00Z" → slice gives "2026-04-26".
 * `localDateKey(new Date())` returns "2026-04-25" — the correct local day.
 */
export function localDateKey(d: Date): string {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}
